import React, { useState } from 'react';

import Drawer from '../../../../components/drawer';
import BankTransfer from './bank-transfer';

const TopUpModal = ({ drawerActive, setDrawerActive }) => {
  const [disp, setDisp] = useState(0);

  const onClose = () => {
    setDisp(0);
    setDrawerActive(false);
  };

  return (
    <>
      <Drawer
        title="Bank Transfer"
        setDrawerActive={onClose}
        drawerActive={drawerActive}
        backIcon={disp > 0}
        onGoback={() => setDisp(0)}
      >
        <Drawer.DrawerBody>
          <BankTransfer onClose={onClose} />
        </Drawer.DrawerBody>
      </Drawer>
    </>
  );
};

export default TopUpModal;
